import { Typography, Grid2 as Grid } from "@mui/material";
import MarketShareImg from "../../assets/pngs/marketShare.png";

const MarketShare = ({ handleProductChartDialogOpen }) => {

    return (
        <>
            <Grid container direction={"column"} spacing={2}>
                <Grid size={8}>
                    <Typography
                        fontWeight={"bold"}
                        fontFamily={"Inter"}
                        fontSize={"16px"}
                        color={"#303030"}
                    >
                        Market Analysis / Share
                    </Typography>
                </Grid>

                <Grid>
                    <img
                        src={MarketShareImg}
                        alt=""
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }} />
                </Grid>
            </Grid>
        </>
    )
}
export default MarketShare;